<template>
    <div class="back-varieties">
        <p>
            Si necesitas menos cantidad te mostraremos las variedades junto al pedido mínimo de planta si lo tienen
        </p>
        <b-button variant="outline-secondary" @click="$emit('click')">
            Selección de variedad <img src="/img/iconos/icon_back_select.svg" alt="Selección de variedad" style="height: 1em; margin-top: -0.175rem;">
        </b-button>
    </div>
</template>

<script>
export default {
    name: "BackVarietiesMinOrder"
}
</script>

<style scoped>
    .back-varieties {
        background-color: #e9e8e8;
        border: 2px solid #0b72b8;
        padding: 0.75em 1.5em;
        margin-top: 1rem;
    }

    .back-varieties p {
        text-align: left;
    }

    .back-varieties button {
        border-radius: 0;
        color: #0b72b8;
        border: 2px solid #0b72b8;
        font-weight: bold;
    }

    .back-varieties button:hover {
        background-color: #c9c9c9;
    }
</style>
